<template>
    <div id="app">
        <v-app id="master">
            <v-dialog
                    v-model="dialog"
                    persistent
                    width="900px"
                    height="600px">
                <v-card v-if="editedItem.risk">
                    <v-card-title>
                        <span class="headline">수정</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    :rules="rulesThreePoint"
                                    v-model="editedItem.risk.severity"
                                    type="number" label="심각도"/>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    :rules="rulesThreePoint"
                                    v-model="editedItem.risk.occurrence"
                                    type="number" label="발생도"/>
                            </v-col>
                        </v-row>
                        <v-text-field
                            label="처리내용"
                            v-model="editedItem.report8D.doc5.report1_2"
                        />
                        <v-text-field
                            label="처리일자"
                            v-model="editedItem.report8D.doc5.date1_1"
                        />
                        <v-text-field
                            label="재검증결과"
                            v-model="editedItem.report8D.doc6.report1"
                        />
                        <v-text-field
                            label="검증자"
                            v-model="editedItem.risk.validator"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn small color="primary" @click="saveItem">저장</v-btn>
                        <v-btn small color="primary" @click="close">취소</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>
            <v-dialog
                style="overflow-y: hidden;"
                scrollable
                v-model="dialog8DReport"
                width="1600px"
            >
                <v-card v-if="editedItem.report8D">
                    <v-card-title class="ma0 pa-0">
                        <v-row no-gutters>
                            <v-col cols="2">
                                <v-card
                                        class="pa-1 pt-3 text-center"
                                        outlined
                                        tile
                                        height="50"
                                >
                                    {{editedItem.report8D.company}}
                                </v-card>
                                <v-card
                                        class="pa-0 pt-0 text-center"
                                        outlined
                                        tile
                                        height="30"
                                >
                                    Date : {{editedItem.report8D.date}}
                                </v-card>
                            </v-col>
                            <v-col cols="6">
                                <v-card
                                        class="ma-0 pa-0 pt-4 text-center"
                                        flat
                                        tile
                                        height="80"
                                >
                                    <p class="display-1 ma-0 pa-0">시정조치 보고서(8D REPORT)</p>
                                    <p class="ma-0 pa-0">심각도: {{editedItem.risk.severity}}   발생도: {{editedItem.risk.occurrence}}    Risk 수준 : {{editedItem.risk.riskLevel}}({{getRiskLevel(editedItem.risk.riskLevel)}})</p>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card
                                        class="pa-0 pt-1"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    1. 개선 팀(Team)
                                </v-card>
                                <v-card
                                        class="ma-0 pa-0"
                                        outlined
                                        tile
                                        height="50"
                                >
                                    <v-textarea
                                            rows="2"
                                            class="ma-0 pa-0"
                                            v-model="editedItem.report8D.doc1.report"
                                    />
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="ma-0 pa-0">
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-card
                                        class="pa-0 pt-1"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    2. 문제정의 (Problem Definition)
                                </v-card>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            7-W Questions
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            Description
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                tile
                                                outlined
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            이미지
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            누가(who)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report1"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            모델(What)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report2"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            시간(when)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report3"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            장소(Where)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report4"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            불량현상(Why)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report5"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            수량(How many)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report6"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            빈도(How often)
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc2.report7"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-card
                                        class="pa-0 pt-1"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    5. 개선대책 (Countermeasure)
                                </v-card>
                                <v-row no-gutters>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            No.
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            조치내용
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            담당
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            완료일
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            적용일
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            상태
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-6 text-center"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <span>생산</span><br>
                                            <span>(발생)</span>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report1_1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report1_2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report1_3"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.date1_1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.date1_2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report1_4"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-6 text-center"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <span>품질</span><br>
                                            <span>(검출)</span>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report2_1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report2_2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report2_3"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.date2_1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.date2_2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="105"
                                        >
                                            <v-textarea
                                                    rows="5"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc5.report2_4"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-card
                                        class="pa-0 pt-1"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    3. 봉쇄조치(Containment within 24hours_following containment sheet)
                                </v-card>
                                <v-card
                                        class="pa-0 ma-0"
                                        outlined
                                        tile
                                        height="105"
                                >
                                    <v-textarea
                                            rows="5"
                                            class="ma-0 pa-0"
                                            v-model="editedItem.report8D.doc3.report"
                                    />
                                </v-card>
                            </v-col>
                            <v-col cols="6">
                                <v-row no-gutters>
                                    <v-col cols="10">
                                        <v-card
                                                class="pa-0 pt-1"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            6. 검증(Verification): 조치사항에 대한 유효성 점검
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            <p class="caption">8D 단계</p>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-card
                                                class="pa-0 pt-1"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            1) 문제 재발이 되었는가?
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="75"
                                        >
                                            <v-textarea
                                                    rows="3"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc6.report1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            Yes
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="75"
                                        >
                                            <v-textarea
                                                    rows="3"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc6.report2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            No
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="75"
                                        >
                                            <v-textarea
                                                    rows="3"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc6.report3"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            검증날짜
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="75"
                                        >
                                            <v-textarea
                                                    rows="3"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc6.date"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2" class="pa-0 ma-0">
                                        <v-card
                                                class="pa-0 ma-0"
                                                flat
                                                tile
                                                height="25"
                                        >
                                            <v-row class="pa-0 ma-0">
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[0]" label="1D"/>
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[4]" label="5D"/>
                                            </v-row>
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="25"
                                        >
                                            <v-row class="pa-0 ma-0">
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[1]" label="2D"/>
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[5]" label="6D"/>
                                            </v-row>
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="25"
                                        >
                                            <v-row class="pa-0 ma-0">
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[2]" label="3D"/>
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[6]" label="7D"/>
                                            </v-row>
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="25"
                                        >
                                            <v-row class="pa-0 ma-0">
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[3]" label="4D"/>
                                                <v-checkbox dense class="pa-0 ma-0" v-model="editedItem.report8D.check[7]" label="8D"/>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-card
                                        class="pa-0 pt-1"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    4. 원인분석(Cause Analysis)
                                </v-card>
                                <v-card
                                        class="pa-0 pt-1 text-center"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    4-1.(발생원인)
                                </v-card>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            1Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report1_1"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            2Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report1_2"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            3Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report1_3"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            4Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report1_4"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            5Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report1_5"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-card
                                                class="pa-0 pt-1"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            7. 재발방지 및 습득교훈(Prevention)
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    표준
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    담당
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    완료
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-row no-gutters>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    수평전개
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    담당
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 pt-1 text-center"
                                                        outlined
                                                        tile
                                                        height="30"
                                                        style="background-color: lightgrey;"
                                                >
                                                    완료
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report1_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report1_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                            class="pa-0 ma-0 text-center"
                                            flat
                                            tile
                                            height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report1_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report1_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report1_5"
                                                    />
                                                </v-card>
                                            </v-col>                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption2"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report2_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report2_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report2_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report2_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report2_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report3_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report3_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report3_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report3_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report3_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report4_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report4_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report4_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report4_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report4_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption5"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report5_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report5_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report5_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report5_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report5_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption6"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report6_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report6_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report6_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report6_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report6_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption7"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report7_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report7_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report7_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report7_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report7_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption8"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report8_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report8_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report8_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report8_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report8_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption9"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report9_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report9_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report9_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report9_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report9_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 pt-1"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.caption10"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report10_1"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report10_2"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 ma-0 text-center"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            →
                                        </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report10_3"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report10_4"
                                                    />
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card
                                                        class="pa-0 ma-0"
                                                        outlined
                                                        tile
                                                        height="30"
                                                >
                                                    <v-textarea
                                                            rows="1"
                                                            class="ma-0 pa-0"
                                                            v-model="editedItem.report8D.doc7.report10_5"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-card
                                        class="pa-0 pt-1 text-center"
                                        outlined
                                        tile
                                        height="30"
                                        style="background-color: lightgrey;"
                                >
                                    4-2.(유출원인)
                                </v-card>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            1Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report2_1"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            2Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report2_2"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            3Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report2_3"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            4Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report2_4"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            5Why
                                        </v-card>
                                    </v-col>
                                    <v-col cols="11">
                                        <v-card
                                                class="ma-0 pa-0"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc4.report2_5"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-card
                                                class="pa-0 pt-1"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            8. 검토 및 종결(Review & Confirm)
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="4">
                                        <v-card
                                                class="pa-0 pt-1"
                                                flat
                                                tile
                                                height="30"
                                        >
                                            - 검토 결과 Comment :
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="120"
                                        >
                                            <v-textarea
                                                    rows="4"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.report1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-10 text-center"
                                                outlined
                                                tile
                                                height="120"
                                                style="background-color: lightgrey;"
                                        >
                                            서명
                                        </v-card>
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            날짜
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            작성
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="90"
                                        >
                                            <v-textarea
                                                    rows="4"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.report2"
                                            />
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.date1"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            검토
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="90"
                                        >
                                            <v-textarea
                                                    rows="4"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.report3"
                                            />
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.date2"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-card
                                                class="pa-0 pt-1 text-center"
                                                outlined
                                                tile
                                                height="30"
                                                style="background-color: lightgrey;"
                                        >
                                            승인
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="90"
                                        >
                                            <v-textarea
                                                    rows="4"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.report4"
                                            />
                                        </v-card>
                                        <v-card
                                                class="pa-0 ma-0"
                                                outlined
                                                tile
                                                height="30"
                                        >
                                            <v-textarea
                                                    rows="1"
                                                    class="ma-0 pa-0"
                                                    v-model="editedItem.report8D.doc8.date3"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="save8DReport">저장</v-btn>
                        <v-btn color="primary" @click="close8DReport">취소</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>
            <v-card  :elevation="0">
                <template>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>이상발생 관리 목록</v-toolbar-title>
                            <v-spacer/>
                            <v-row>
                                <v-spacer/>

                                <v-radio-group class="mt-1 mr-7" v-model="controlChart" label="관리도" row>
                                    <v-radio label="X-MR" value="XMR"></v-radio>
                                    <v-radio label="X̅-R" value="XBarR"></v-radio>
                                    <v-radio label="X̅-s" value="XBars"></v-radio>
                                </v-radio-group>

                                <v-radio-group class="mt-1 mr-7" v-model="riskLevel" label="Risk" row>
                                    <v-radio label="All" value="All"></v-radio>
                                    <v-radio label="H" value="H"></v-radio>
                                    <v-radio label="M" value="M"></v-radio>
                                    <v-radio label="L" value="L"></v-radio>
                                </v-radio-group>

                                <v-radio-group class="mt-1 mr-5" v-model="warning" label="경고등" row>
                                    <v-radio label="All" value="All"></v-radio>
                                    <v-radio label="평가전" color="red" value="red"></v-radio>
                                    <v-radio label="진행중" color="yellow" value="yellow"></v-radio>
                                    <v-radio label="완료" color="green" value="green"></v-radio>
                                </v-radio-group>

                                <v-btn color="primary" small @click="search" class="ma-1">
                                    <v-icon left small>
                                        mdi-magnify
                                    </v-icon>
                                    <span>검색</span>
                                </v-btn>
                            </v-row>
                        </v-toolbar>
                    </template>
                <v-data-table
                    :headers="headers"
                    :items="DataList"
                    sort-by="name"
                >
                    
                    <template v-slot:item.warning="{ item }">
                        <v-icon :color="item.warning">mdi-traffic-light</v-icon>
                    </template>
                    <template v-slot:item.risk.abnormalStatus="{ item }">
                        <v-row align="start">
                            <span align="start" v-html="item.risk.abnormalStatus"></span>
                        </v-row>
                    </template>
                    <template v-slot:item.risk.riskLevel="{ item }">
                        <template v-if="item.risk.riskLevel>6">
                            {{item.risk.riskLevel}} (H)
                        </template>
                        <template v-if="item.risk.riskLevel<=6&&item.risk.riskLevel>=4">
                            {{item.risk.riskLevel}} (M)
                        </template>
                        <template v-if="item.risk.riskLevel<4">
                            {{item.risk.riskLevel}} (L)
                        </template>
                    </template>
                    <template v-slot:item.baseInfo1="{ item }">
                        <v-row align="start">
                            <span>공장 : {{item.organizationMaster.list[1].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>라인 : {{item.organizationMaster.list[3].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>공정 : {{item.organizationMaster.list[4].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>제품명 : {{item.productMaster.list[0].data}}</span>
                        </v-row>
                    </template>

                    <template v-slot:item.baseInfo2="{ item }">
                        <v-row align="start">
                            <span>모델코드 : {{item.productMaster.list[1].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>품목코드 : {{item.productMaster.list[2].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>고객 : {{item.customerMaster.list[0].data}}</span>
                        </v-row>
                        <v-row align="start">
                            <span>관리항목 : {{item.spcmaster.list[5].data}}</span>
                        </v-row>
                    </template>

                    <template v-slot:item.step="{ item }">
                        <template v-if="item.report8D.checkCount > 0">
                            <v-row>
                                <v-col>
                                    <v-row align="start" v-if="item.report8D.check[0]==true"><span>1D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[1]==true"><span>2D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[2]==true"><span>3D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[3]==true"><span>4D</span></v-row>
                                </v-col>
                                <v-col>
                                    <v-row align="start" v-if="item.report8D.check[4]==true"><span>5D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[5]==true"><span>6D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[6]==true"><span>7D</span></v-row>
                                    <v-row align="start" v-if="item.report8D.check[7]==true"><span>8D</span></v-row>
                                </v-col>
                            </v-row>
                        </template>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" small @click="editItem(item)" class="ma-1">
                            <v-icon left small>
                                mdi-border-color
                            </v-icon>
                            <span>수정</span>
                        </v-btn>
                        <v-btn color="primary" small @click="editItem8DReport(item)" class="ma-1">
                            <v-icon left small>
                                mdi-border-color
                            </v-icon>
                            <span>8D 리포트</span>
                        </v-btn>
                    </template>
                </v-data-table>

            </v-card>
        </v-app>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'AnomalyList',

  data: () => ({
    dialog8DReport: false,
    dialog: false,

    rulesThreePoint: [
      v => !!v || '데이터를 입력해 주세요.',
      v => v >= 0 || '0이상의 수를 입력해 주세요.',
      v => v <= 3 || '3이하의 수를 입력해 주세요.'
    ],
    headers: [
      {
        text: '경고등',
        align: 'center',
        value: 'warning'
      },
      {
        text: '발생구분',
        align: 'center',
        value: 'risk.occurrenceClassification'
      },
      {
        text: '이상발생현황',
        align: 'center',
        value: 'risk.abnormalStatus'
      },
      {
        text: '발생시기',
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: '심각도',
        align: 'center',
        value: 'risk.severity'
      },
      {
        text: '발생도',
        align: 'center',
        value: 'risk.occurrence'
      },
      {
        text: 'Risk수준',
        align: 'center',
        value: 'risk.riskLevel'
      },
      {
        text: '기준정보1',
        align: 'center',
        value: 'baseInfo1'
      },
      {
        text: '기준정보2',
        align: 'left',
        value: 'baseInfo2'
      },
      {
        text: '처리내용',
        align: 'center',
        value: 'report8D.doc5.report1_2'
      },
      {
        text: '처리일자',
        align: 'center',
        value: 'report8D.doc5.date1_1'
      },
      {
        text: '재검증결과',
        align: 'center',
        value: 'report8D.doc6.report1'
      },
      {
        text: '검증자',
        align: 'center',
        value: 'risk.validator'
      },
      /*
      {
        text: '문서화된 정보',
        align: 'center',
        value: 'risk.document'
      },
      */
      {
        text: '단계',
        align: 'center',
        value: 'step'
      },
      {
        text: '문서화된 정보',
        align: 'center',
        value: 'action',
        sortable: false
      }
    ],

    controlChart: 'XMR',

    riskLevel: 'All',

    warning: 'All',

    // 8D 리포트.
    report8DDefault: {
      company: '',
      date: '',
      check: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false
      },
      checkCount: 0,
      doc1: { report: '' },
      doc2: {
        report1: '',
        report2: '',
        report3: '',
        report4: '',
        report5: '',
        report6: '',
        report7: ''
      },
      doc3: { report: '' },
      doc4: {
        report1_1: '',
        report1_2: '',
        report1_3: '',
        report1_4: '',
        report1_5: '',
        report2_1: '',
        report2_2: '',
        report2_3: '',
        report2_4: '',
        report2_5: ''
      },
      doc5: {
        report1_1: '',
        report1_2: '',
        report1_3: '',
        report1_4: '',
        report2_1: '',
        report2_2: '',
        report2_3: '',
        report2_4: '',
        date1_1: '',
        date1_2: '',
        date2_1: '',
        date2_2: ''
      },
      doc6: {
        report1: '',
        report2: '',
        report3: '',
        date: ''
      },
      doc7: {
        caption1: 'PFMEA(공정고장형태)',
        caption2: 'CP(관리계획서)',
        caption3: 'SOS(작업표준서)',
        caption4: 'Drawing',
        caption5: 'Error proofing',
        caption6: '교육일지',
        caption7: '체크 시트',
        caption8: '',
        caption9: '',
        caption10: '',

        report1_1: '',
        report1_2: '',
        report1_3: '',
        report1_4: '',
        report1_5: '',

        report2_1: '',
        report2_2: '',
        report2_3: '',
        report2_4: '',
        report2_5: '',

        report3_1: '',
        report3_2: '',
        report3_3: '',
        report3_4: '',
        report3_5: '',

        report4_1: '',
        report4_2: '',
        report4_3: '',
        report4_4: '',
        report4_5: '',

        report5_1: '',
        report5_2: '',
        report5_3: '',
        report5_4: '',
        report5_5: '',

        report6_1: '',
        report6_2: '',
        report6_3: '',
        report6_4: '',
        report6_5: '',

        report7_1: '',
        report7_2: '',
        report7_3: '',
        report7_4: '',
        report7_5: '',

        report8_1: '',
        report8_2: '',
        report8_3: '',
        report8_4: '',
        report8_5: '',

        report9_1: '',
        report9_2: '',
        report9_3: '',
        report9_4: '',
        report9_5: '',

        report10_1: '',
        report10_2: '',
        report10_3: '',
        report10_4: '',
        report10_5: ''
      },
      doc8: {
        report1: '',
        report2: '',
        report3: '',
        report4: '',
        date1: '',
        date2: '',
        date3: ''
      }
    },

    DataList: [],
    editedIndex: -1,
    editedItem: { },
    defaultItem: { }
  }),

  created () {
    // this.getItemList()
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '추가하기' : '수정하기'
    }
  },

  watch: {
    dialog8DRerport (val) {
      val || this.close8DReport()
    }
  },

  methods: {

    search () {
        /*
            경고등           warning
            발생 구분        occurrenceClassification
            이상 발생 현황  abnormalStatus
            발생 시기 when
            심각도   severity
            발생도   occurrence
            Risk 수준   riskLevel
            처리 내용 processingContent
            처리 일자 processingDate
            재검증결과 revalidationResult
            검증자   validator
            문서화된 정보   document
        */
      // DB 리스트 가져오기.
      this.DataList = []
      let query = '?controlChart=' + this.controlChart + '&riskLevel=' + this.riskLevel + '&warning=' + this.warning 

      this.$axios.get('/api/spcs/anomaly' + query, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get spcs anomaly -> ' + res)
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].risk === null || typeof res.data[i].risk === 'undefined') {
                res.data[i].risk = {}
            }

            // 심각도 초기화.
            if (res.data[i].risk.severity === null || typeof res.data[i].risk.severity === 'undefined') {
                res.data[i].risk.severity = 0
            }

            // 발생도 초기화.
            if (res.data[i].risk.occurrence === null || typeof res.data[i].risk.occurrence === 'undefined') {
                res.data[i].risk.occurrence = 0
            }

            // Risk 수준 초기화.
            if (res.data[i].risk.riskLevel === null || typeof res.data[i].risk.riskLevel === 'undefined') {
                res.data[i].risk.riskLevel = 0
            }

            // 검증자 초기화.
            if (res.data[i].risk.riskLevel === null || typeof res.data[i].risk.riskLevel === 'undefined') {
                res.data[i].risk.validator = ''
            }

            // 이상현상.
            if (res.data[i].risk.abnormalStatus === null || typeof res.data[i].risk.abnormalStatus === 'undefined') {
                res.data[i].risk.abnormalStatus = ''
                if (res.data[i].anomaly0.indexOf('A') !== -1) {
                res.data[i].risk.abnormalStatus += 'A: 관리 한계선 벗어남.<br>'
                }
                if (res.data[i].anomaly0.indexOf('B') !== -1) {
                res.data[i].risk.abnormalStatus += 'B: 중심선 한쪽으로만 9개점.<br>'
                }
                if (res.data[i].anomaly0.indexOf('C') !== -1) {
                res.data[i].risk.abnormalStatus += 'C: 연속 6점이 증가, 감소.<br>'
                }
                if (res.data[i].anomaly0.indexOf('D') !== -1) {
                res.data[i].risk.abnormalStatus += 'D: 연속 14점이 증가, 감소 반복.<br>'
                }
                if (res.data[i].anomaly0.indexOf('E') !== -1) {
                res.data[i].risk.abnormalStatus += 'E: 연속 3점 중 2점이 어느 한쪽(±3σ)<br>'
                }
                if (res.data[i].anomaly0.indexOf('F') !== -1) {
                res.data[i].risk.abnormalStatus += 'F: 연속 5점 중 4점이 ±1σ, ±2σ<br>'
                }
                if (res.data[i].anomaly0.indexOf('G') !== -1) {
                res.data[i].risk.abnormalStatus += 'G: 연속한 15점이 ±1σ<br>'
                }
                if (res.data[i].anomaly0.indexOf('H') !== -1) {
                res.data[i].risk.abnormalStatus += 'H: 연속 8점이  ±1σ, ±2σ<br>'
                }
            }

            if (res.data[i].report8D === null || typeof res.data[i].report8D === 'undefined') {
                res.data[i].report8D = {}
            }
            // 존재 하지 않는 항목 자동 추가.
            this.$Common.checkObject(res.data[i].report8D, this.report8DDefault)

            // 발생 구분.
            if (res.data[i].risk.occurrenceClassification === null || typeof res.data[i].risk.occurrenceClassification === 'undefined') {
                res.data[i].risk.occurrenceClassification = '관리도'
            }

            // 경고등.
            if (res.data[i].warning === null) {
                res.data[i].warning = 'red'
            }

            this.DataList.push(res.data[i])
          }
        })
        .catch((e) => {
          console.log('failed get spcs anomaly -> ' + JSON.stringify(e.response.data))
        })
    },

    checkWarning () {
      // Red.
      this.editedItem.warning = 'red'
      let Length0 = false
      if (typeof this.editedItem.risk.validator !== 'undefined') {
        Length0 = this.editedItem.risk.validator.length > 0
      }

      // High.
      if (this.editedItem.risk.riskLevel > 6) {
        // Yellow.
        if (Length0 ||
          this.editedItem.report8D.check[0] === true ||
          this.editedItem.report8D.check[1] === true ||
          this.editedItem.report8D.check[2] === true ||
          this.editedItem.report8D.check[3] === true ||
          this.editedItem.report8D.check[4] === true ||
          this.editedItem.report8D.check[5] === true ||
          this.editedItem.report8D.check[6] === true ||
          this.editedItem.report8D.check[7] === true) {
          this.editedItem.warning = 'yellow'
        }
        // Green.
        if (Length0 &&
          this.editedItem.report8D.check[0] === true &&
          this.editedItem.report8D.check[1] === true &&
          this.editedItem.report8D.check[2] === true &&
          this.editedItem.report8D.check[3] === true &&
          this.editedItem.report8D.check[4] === true &&
          this.editedItem.report8D.check[5] === true &&
          this.editedItem.report8D.check[6] === true &&
          this.editedItem.report8D.check[7] === true) {
          this.editedItem.warning = 'green'
        }
      }
      // Middle.
      if (this.editedItem.risk.riskLevel <= 6 && this.editedItem.risk.riskLevel >= 4) {
        // Yellow.
        if (Length0 ||
          this.editedItem.report8D.check[0] === true ||
          this.editedItem.report8D.check[1] === true ||
          this.editedItem.report8D.check[2] === true ||
          this.editedItem.report8D.check[3] === true ||
          this.editedItem.report8D.check[4] === true ||
          this.editedItem.report8D.check[5] === true) {
          this.editedItem.warning = 'yellow'
        }
        // Green.
        if (Length0 &&
          this.editedItem.report8D.check[0] === true &&
          this.editedItem.report8D.check[1] === true &&
          this.editedItem.report8D.check[2] === true &&
          this.editedItem.report8D.check[3] === true &&
          this.editedItem.report8D.check[4] === true &&
          this.editedItem.report8D.check[5] === true) {
          this.editedItem.warning = 'green'
        }
      }
      // Low.
      if (this.editedItem.risk.riskLevel < 4) {
        let Length1 = this.editedItem.report8D.doc5.report1_2.length > 0
        let Length2 = this.editedItem.report8D.doc5.date1_1.length > 0
        let Length3 = this.editedItem.report8D.doc6.report1.length > 0
        // Yellow.
        if (Length0 || Length1 || Length2 || Length3) {
          this.editedItem.warning = 'yellow'
        }
        // Green
        if (Length0 && Length1 && Length2 && Length3) {
          this.editedItem.warning = 'green'
        }
      }
    },

    save8DReport () {
      // 8D 리포트 단계 카운트.
      this.editedItem.report8D.checkCount = 0
      for (let i = 0; i < 8; i++) {
        if (this.editedItem.report8D.check[i.toString()]) {
          this.editedItem.report8D.checkCount++
        }
      }

      // 경고등 상태 체크.
      this.checkWarning()
      let data= {
          id: this.editedItem.id,
          warning: this.editedItem.warning,
          risk: this.editedItem.risk,
          report8D: this.editedItem.report8D
      }
      this.$axios.put('/api/spcs/anomaly', data, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded put spcs -> ' + res)
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          this.close()
          this.$dialog.alert('8D 리포트가 수정 되었습니다.', { okText: '확인' }).then(function () {
          })
        })
        .catch((e) => {
          console.log('failed put spcs -> ' + JSON.stringify(e.response.data))
        })
    },

    saveItem () {
      this.editedItem.risk.severity = parseInt(this.editedItem.risk.severity)
      this.editedItem.risk.occurrence = parseInt(this.editedItem.risk.occurrence)
      this.editedItem.risk.riskLevel = this.editedItem.risk.severity * this.editedItem.risk.occurrence

      // 경고등 상태 체크.
      this.checkWarning()
      let data= {
          id: this.editedItem.id,
          warning: this.editedItem.warning,
          risk: this.editedItem.risk,
          report8D: this.editedItem.report8D
      }
      this.$axios.put('/api/spcs/anomaly', data, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded put spcs -> ' + res)
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          this.close()
          this.$dialog.alert('이상원인이 수정 되었습니다.', { okText: '확인' }).then(function () {
          })
        })
        .catch((e) => {
          console.log('failed put spcs -> ' + JSON.stringify(e.response.data))
        })
    },

    editItem: function (item) {
      this.editedIndex = this.DataList.indexOf(item)
      this.editedItem = this.$Common.cloneObject(item)
      this.dialog = true
    },

    editItem8DReport: function (item) {
      this.editedIndex = this.DataList.indexOf(item)
      this.editedItem = this.$Common.cloneObject(item)
      this.editedItem.report8D.company = this.$Define.COMPANY
      if (typeof this.editedItem.report8D.date === 'undefined' || this.editedItem.report8D.date === '') {
        this.editedItem.report8D.date = moment(new Date()).format('YYYY-MM-DD')
      }
      this.dialog8DReport = true
    },

    close8DReport () {
      this.dialog8DReport = false
    },
    close () {
      this.dialog = false
    },
    getRiskLevel (value) {
      if (value > 6) {
        return 'H'
      }
      if (value < 4) {
        return 'L'
      }
      return 'M'
    }
  }
}
</script>

<style scoped/>
